<template>

	<nav class="pagination is-centered" role="navigation" aria-label="pagination">
		<a class="pagination-previous" @click.prevent="previousPage" :disabled="!prev_page_url">Previous</a>
		<a class="pagination-next" @click.prevent="nextPage" :disabled="!next_page_url">Next page</a>
		<ul class="pagination-list is-hidden-mobile">
			
			<!-- First Page -->
			<li><a class="pagination-link" data-page="1" :class="{'is-current' : current_page == 1 }" @click.prevent="gotoPage" aria-label="Goto page 1">1</a></li>
			<!-- /First Page -->
			
			<li><span class="pagination-ellipsis">&hellip;</span></li>

			<template v-if="current_page <= 3">
				<li><a class="pagination-link" :class="{'is-current':current_page == 2}" data-page="2" aria-label="Goto page 2" @click.prevent="gotoPage">2</a></li>
				<li><a class="pagination-link" :class="{'is-current':current_page == 3}" data-page="3" aria-label="Goto page 3" @click.prevent="gotoPage">3</a></li>
				<li><a class="pagination-link" :class="{'is-current':current_page == 4}" data-page="4" aria-label="Goto page 4" @click.prevent="gotoPage">4</a></li>
			</template>
			

			<template v-if="current_page > 3 && current_page < last_page - 1">
				<li><a class="pagination-link" :data-page="current_page - 1" aria-label="Goto page 2" @click.prevent="gotoPage">{{ current_page - 1 }}</a></li>
				
				<li><a class="pagination-link is-current" :data-page="current_page" :aria-label="'Page ' + current_page" aria-current="page" @click.prevent="gotoPage">{{ current_page }}</a></li>

				<li><a class="pagination-link" :data-page="current_page + 1" :aria-label="'Page ' + current_page" @click.prevent="gotoPage">{{ current_page + 1}}</a></li>
			</template>

			<template v-if="current_page > last_page - 2">
				<li><a class="pagination-link" :data-page="last_page - 3" :aria-label="'Goto page ' + last_page - 3" @click.prevent="gotoPage">{{ last_page - 3 }}</a></li>
				
				<li><a class="pagination-link" :class="{'is-current':current_page == last_page - 2}" :data-page="current_page - 2" :aria-label="'Page ' + current_page - 2" aria-current="page" @click.prevent="gotoPage">{{ last_page - 2 }}</a></li>

				<li><a class="pagination-link" :class="{'is-current':current_page == last_page - 1}" :data-page="last_page - 1" :aria-label="'Page ' + last_page - 1" @click.prevent="gotoPage">{{ last_page - 1}}</a></li>
			</template>


			<li><span class="pagination-ellipsis">&hellip;</span></li>

			<!-- Last page -->
			<li><a class="pagination-link" :data-page="last_page" :class="{'is-current' : current_page == last_page }" :aria-label="'Goto page '+ last_page" @click.stop="gotoPage">{{last_page}}</a>
			</li>
			<!-- /Last page -->
		</ul>
	</nav>
</template>

<script>
	export default {
		props:{
			prev_page_url:{
				type: String,
				default: null
			},
			next_page_url:{
				type: String,
				default: null
			},
			current_page: {
				type: Number,
				default: 1,
				required: true
			},
			last_page: {
				type: Number,
				default: 2,
				required: true
			}
		},
		name: 'Pagination',

		data() {
			return {

			};
		},
		methods:{
			nextPage(){
				this.$emit('nextPage')
			},
			previousPage(){
				this.$emit('previousPage')
			},
			gotoPage(event){
				this.$emit('gotoPage',event)
			}
		}
	};
</script>

<style lang="css" scoped>
</style>
